import React from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import {Button, Card, Flex, Heading} from 'rebass';
import {AdaptedDropdown, AdaptedInput, AdaptedSwitch} from "./FormField";
import {Field, Form} from 'react-final-form';

import {schoolSelectors} from "../../store/school";

import {buttonMarginTop, PopupWrapper} from "./styles";

// const required = value => (value ? undefined : 'Required')

const GENER_OPTIONS = [
    {value: '', label: 'Select'},
    {value: 'M', label: 'Male'},
    {value: 'F', label: 'Female'}
];

const GRADE_OPTIONS = [
	{value: '', label: 'Select'},
	{value: '3', label: '3'},
	{value: '4', label: '4'},
	{value: '5', label: '5'},
	{value: '6', label: '6'},
];

const StudentForm = props => {

	const {onSubmit, toggleOverlay, initialValues} = props;

	let title = 'New Student'
	if(initialValues.first_name || initialValues.last_name){
		title = initialValues.first_name + ' ' + initialValues.last_name;
	}
	const isNew = initialValues.first_name ? false : true;
	const dorms  = (props.schoolInfo && props.schoolInfo.dorms) || [];
	const dormOptions = dorms.map(dorm => {
		return {
			value : dorm.id,
			label: dorm.name
		}
	});
	
	return (
		<PopupWrapper>
			<Form
				onSubmit={onSubmit}
				initialValues={initialValues}
				render={({ handleSubmit, form, submitting, pristine, values }) => {
					return (
						<form id="exampleForm" onSubmit={handleSubmit}>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Heading>{title}</Heading>

								<Flex flexDirection={'row'}>
									<Heading as={'h5'} pr={2}>Activate</Heading>
									<Field
										name={'activated'}
										component={AdaptedSwitch}
										type={'checkbox'}
									/>
								</Flex>
							</Flex>
							<Button variant={'main'} m={1} mt={buttonMarginTop}
									// bg={!values.name ? 'meta' : 'green'}
									bg={'green'}
							        // disabled={!values.name}
							        type="submit"
							>
								Save
							</Button>
							<Button variant={'main'} m={1} mt={buttonMarginTop} bg={'gray'} onClick={(e) =>{
								e.preventDefault();
								form.reset()
								toggleOverlay()
							}}>Cancel</Button>

                            <Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'column'} mt={3}>
                                    <Heading as={'h4'} mt={3} mb={2}>First Name</Heading>
                                    <Card boxShadow={'main'}>
										<Field
											name="first_name"
											component={AdaptedInput}
											type="text"
											placeholder="First Name goes here..."
											//validate={required}
											filterTitle={'First Name'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
                                </Flex>
                                <Flex flexDirection={'column'} mt={3}>
                                    <Heading as={'h4'} mt={3} mb={2}>Last Name</Heading>
									<Card boxShadow={'main'}>
										<Field
											name="last_name"
											component={AdaptedInput}
											type="text"
											placeholder="Last Name goes here..."
											//validate={required}
											filterTitle={'Last Name'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
                                 </Flex>
                            </Flex>

							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'column'} mt={3}>
                                    <Heading as={'h4'} mt={3} mb={2}>Email</Heading>
                                    <Card boxShadow={'main'}>
										<Field
											name="email"
											component={AdaptedInput}
											type="text"
											placeholder="Email goes here..."
											//validate={required}
											filterTitle={'Email'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
                                </Flex>
                                <Flex flexDirection={'column'} mt={3}>
                                    <Heading as={'h4'} mt={3} mb={2}>Home Phone</Heading>
									<Card boxShadow={'main'}>
										<Field
											name="home_phone"
											component={AdaptedInput}
											type="text"
											placeholder="Home Phone goes here..."
											//validate={required}
											filterTitle={'Home Phone'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
                                 </Flex>
                            </Flex>

							{/* Parents Fields  */}
							<Heading as={'h4'} mt={3}>Parent1</Heading>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>First Name</Heading>
									<Card boxShadow={'main'}>
										<Field
											name="parents_data[0].first_name"
											component={AdaptedInput}
											type="text"
											placeholder="First Name goes here..."
											//validate={required}
											filterTitle={'First Name'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>Last Name</Heading>
									<Card boxShadow={'main'}>
										<Field
											// name="f_last_name"
											name="parents_data[0].last_name"
											component={AdaptedInput}
											type="text"
											placeholder="Last Name goes here..."
											//validate={required}
											filterTitle={'Last Name'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
							</Flex>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>Email</Heading>
									<Card boxShadow={'main'}>
										<Field
											//name="f_email"
											name="parents_data[0].email"
											component={AdaptedInput}
											type="text"
											placeholder="Email goes here..."
											//validate={required}
											filterTitle={'Email'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>Mobile</Heading>
									<Card boxShadow={'main'}>
										<Field
											// name="f_mobile"
											name="parents_data[0].mobile"
											component={AdaptedInput}
											type="text"
											placeholder="Mobile goes here..."
											//validate={required}
											filterTitle={'Mobile'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
							</Flex>
					
							<Heading as={'h4'} mt={3}>Parent2</Heading>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>First Name</Heading>
									<Card boxShadow={'main'}>
										<Field
											name="parents_data[1].first_name"
											component={AdaptedInput}
											type="text"
											placeholder="First Name goes here..."
											//validate={required}
											filterTitle={'First Name'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>Last Name</Heading>
									<Card boxShadow={'main'}>
										<Field
											// name="f_last_name"
											name="parents_data[1].last_name"
											component={AdaptedInput}
											type="text"
											placeholder="Last Name goes here..."
											//validate={required}
											filterTitle={'Last Name'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
							</Flex>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>Email</Heading>
									<Card boxShadow={'main'}>
										<Field
											//name="f_email"
											name="parents_data[1].email"
											component={AdaptedInput}
											type="text"
											placeholder="Email goes here..."
											//validate={required}
											filterTitle={'Email'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
								<Flex flexDirection={'column'} mt={3}>
									<Heading as={'h4'} mt={3} mb={2}>Mobile</Heading>
									<Card boxShadow={'main'}>
										<Field
											// name="f_mobile"
											name="parents_data[1].mobile"
											component={AdaptedInput}
											type="text"
											placeholder="Mobile goes here..."
											//validate={required}
											filterTitle={'Mobile'}
											disabled={!isNew && initialValues.is_modified !== true}
										/>
									</Card>
								</Flex>
							</Flex>

							<Heading as={'h4'} mt={3} mb={2}>Details</Heading>
							<Flex flexDirection={'row'} justifyContent={'space-between'}  alignItems={'center'}>
								<Flex flexDirection={'row'} alignItems={'center'} mt={3}>
									<Heading as={'h3'} color={'gray'} mr={2}>Gender</Heading>
									{
										(isNew || initialValues.is_modified === true) ?
										<Field
											name="gender"
											component={AdaptedDropdown}
											options={GENER_OPTIONS}
											filterTitle={'Select'}
											showSelected={true}
											titleFontSize={4}
											//validate={required}
										/>
										:
										<Field
											name="gender"
											component={AdaptedInput}
											type="text"
											filterTitle={'Select'}
											showSelected={true}
											titleFontSize={10}
											disabled
										/>
									}
								</Flex>
								<Flex flexDirection={'row'} alignItems={'center'} mt={3}>
									<Heading as={'h3'} color={'gray'} mr={2}>Grade</Heading>
									{
										(isNew || initialValues.is_modified === true) ?
										<Field
											name="grade"
											component={AdaptedDropdown}
											options={GRADE_OPTIONS}
											filterTitle={'Select'}
											showSelected={true}
											titleFontSize={4}
											//validate={required}
										/>
										:
										<Field
											name="grade"
											component={AdaptedInput}
											type="text"
											filterTitle={'Select'}
											showSelected={true}
											titleFontSize={10}
											disabled
										/>
									}
								</Flex>
								<Flex flexDirection={'row'} alignItems={'center'} mt={3}>
									<Heading as={'h3'} color={'gray'} mr={2}>Dorm</Heading>
									{
										(isNew || initialValues.is_modified === true) ?
										<Field
											name="dorm"
											component={AdaptedDropdown}
											options={dormOptions}
											filterTitle={'Select'}
											showSelected={true}
											titleFontSize={4}
											//validate={required}
										/>
										:
										<Field
											name="dorm"
											component={AdaptedInput}
											type="text"
											filterTitle={'Select'}
											showSelected={true}
											titleFontSize={10}
											disabled
										/>
									}
								</Flex>
							</Flex>
							

							<Flex flexDirection={'row'} mt={3} justifyContent={'space-between'}>
                                <Flex flexDirection={'row'} mt={3}>
                                    <Heading as={'h4'} mb={2} mr={2} >Prefect?</Heading>
                                    <Field
                                        name={'is_prefect'}
                                        component={AdaptedSwitch}
										type={'checkbox'}
                                    />
                                </Flex>
                                <Flex flexDirection={'row'} mt={3}>
                                    <Heading as={'h4'} mb={2} mr={2} >Boarding?</Heading>
                                    <Field
                                        name={'is_boarding'}
                                        component={AdaptedSwitch}
										type={'checkbox'}
										disabled={!isNew && initialValues.is_modified !== true}
                                    />
                                </Flex>
							</Flex>
							
						</form>
					)
				}}
			/>
		</PopupWrapper>
	);
};

StudentForm.propTypes = {
	onSubmit: PropTypes.func,
	toggleOverlay: PropTypes.func,
	initialValues: PropTypes.object
};

StudentForm.defaultProps = {
	onSubmit: (values) => console.log('New Student values', values),
	toggleOverlay: () => console.log("Closed overlay"),
	initialValues: {activated: false}
};

const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
});

export default connect(
	mapStateToProps
)(StudentForm);

